// Frontend mirror of backend/src/utils/ticketId.js — keep in sync.
// Rendered ids look like T-JH-87664 / R-BP-12 / C-JH-32476, where the
// initials come from the creator's full name. Unknown creator -> "XX".

export function getInitials(fullName) {
  if (!fullName) return 'XX';
  const parts = String(fullName).trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return 'XX';
  const first = parts[0].charAt(0);
  const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';
  const initials = (first + last).toUpperCase();
  return initials || 'XX';
}

export function formatTicketId(prefix, id, creatorName) {
  return `${prefix}-${getInitials(creatorName)}-${id}`;
}
